import axios from 'axios'
import config from '../config/app'

const PATH = '/company'
// const PATH1 = '/companyEmpacct'
const VERSION = '/v2'

export default {
  liveSearch (search, additional, newOrder = 'asc', params = []) {
    params['limit'] = 200
    params['offset'] = 0
    params['status'] = 1

    // limit: 200,
    // offset: 0,
    // status: 1
    // blocked: 'no',
    // role_id: [6, 7],
    // order: {'company_name': 'asc'}

    if (newOrder === 'asc') {
      params['order'] = {'company_name': 'asc'}
    } else {
      params['order'] = {'id': 'desc'}
    }
    if (search) {
      params.search = search
    }
    return this.get(params, additional)
  },
  liveSearchAccount (search, additional, newOrder = 'asc', params = []) {
    params['limit'] = 200
    params['offset'] = 0
    params['status'] = 1

    // limit: 200,
    // offset: 0,
    // status: 1
    // blocked: 'no',
    // role_id: [6, 7],
    // order: {'company_name': 'asc'}

    if (newOrder === 'asc') {
      params['order'] = {'company_name': 'asc'}
    } else {
      params['order'] = {'id': 'desc'}
    }
    if (search) {
      params.search = search
    }
    return this.get(params, additional)
  },
  /**
   * Base method for get companies
   *
   * @param params
   * @param additional
   * @returns {Promise}
   */
  get (params, additional) {
    params = typeof params === 'object' && params !== null ? params : {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    let url = config.server + PATH + '?' + stringParams

    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  /**
   *
   * @param companyId
   * @param additional
   * @returns {*|Promise}
   */
  getCompanyById (companyId, additional) {
    return new Promise((resolve, reject) => {
      this.get({id: companyId}, additional).then((response) => {
        resolve(response.data[0])
      }, (error) => {
        reject(error)
      })
    })
  },
  update (companyId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/company/' + companyId,
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateCompanyDowngradeAccess (companyId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/company/update-downgrade-access/' + companyId,
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateGivingTarget (companyId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/company/update-giving-benchmark/' + companyId,
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateIcon (companyId, blob, imgtype = '') {
    let fd = new FormData()
    if (imgtype !== '') {
      if (blob) {
        fd.append('company_banner_img', new File([blob], 'image.jpg', {type: 'image/jpeg'}))
      } else {
        fd.append('company_banner_img', null)
      }
    } else {
      if (blob) {
        fd.append('company_icon', new File([blob], 'image.jpg', {type: 'image/jpeg'}))
      } else {
        fd.append('company_icon', null)
      }
    }
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/company/' + companyId + '/image',
        mimeType: 'multipart/form-data',
        data: fd
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateLogo (companyId, blob) {
    let fd = new FormData()
    if (blob) {
      fd.append('company_logo', new File([blob], 'image.jpg', {type: 'image/jpeg'}))
    } else {
      fd.append('company_logo', null)
    }
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/company/' + companyId + '/image',
        mimeType: 'multipart/form-data',
        data: fd
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompanyContributionsById (companyId) {
    return new Promise((resolve, reject) => {
      axios.get(config.server + '/company/contributions?company_id=' + companyId).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompanyEmail (companyId) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/company/email', {id: companyId}).then((response) => {
        resolve(response.data.email)
      }, (error) => {
        reject(error)
      })
    })
  },
  getActiveCompany (compnayId) { // Check company status "is_show_listing" 1 or 0
    let url = config.server + '/company/valid-company?id=' + compnayId
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompanyMainUser (params, additional = null) {
    params = typeof params === 'object' && params !== null ? params : {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    let url = config.server + VERSION + PATH + '/main?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getPublicCompanyMainUser (params, additional = null) {
    params = typeof params === 'object' && params !== null ? params : {}
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')

    let url = config.server + VERSION + PATH + '/get-company-user?' + stringParams
    return new Promise((resolve, reject) => {
      axios.get(url).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  getValidBusinessProfile (companyId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'GET',
        url: config.server + '/company/valid-bussiness-profile/' + companyId,
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  newGetBusiness (params, additional, urlFilters = null, user = null) {
    if (additional !== null && additional !== undefined) {
      params.additional = additional.join(',')
    }
    let stringParams = Object.keys(params).filter((i) => { return params[i] !== '' && params[i] !== null }).map((k) => {
      return params[k] !== null && params[k] !== undefined && typeof params[k] === 'object' ? Object.keys(params[k]).map((m) => { return encodeURIComponent(k) + '[' + encodeURIComponent(m) + ']' + '=' + encodeURIComponent(params[k][m]) }).join('&') : encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
    }).join('&')
    if (urlFilters !== null && urlFilters !== undefined) {
      stringParams = stringParams + '&' + urlFilters
    }
    let url = ''
    if (user) {
      url = config.server + VERSION + PATH + '?' + stringParams
    } else {
      url = config.server + VERSION + '/guest' + PATH + '/business-listing?' + stringParams
    }
    // console.log('url', url)
    return new Promise((resolve, reject) => {
      axios.post(url).then((response) => {
        // console.log('response', response)
        resolve(response.data.original)
      }, (error) => {
        reject(error)
      })
    })
  },
  getCompanyfromCountry (data) {
    return new Promise((resolve, reject) => {
      axios.post(config.server + '/company/get-companies-from-country', data).then((response) => {
        resolve(response.data.email)
      }, (error) => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/company.js